import VehicleCard from './VehicleCard';

export default VehicleCard;
